import {
  RegularExpenseStateTypes,
  RegularExpenseActionTypes,
} from "./RegularExpense.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: RegularExpenseStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const RegularExpenseReducer = (
  state: RegularExpenseStateTypes = INITIAL_STATE,
  action: any
): RegularExpenseStateTypes => {
  switch (action.type) {
    case RegularExpenseActionTypes.FETCH_ALL_REGULAR_EXPENSE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case RegularExpenseActionTypes.FETCH_ALL_REGULAR_EXPENSE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case RegularExpenseActionTypes.FETCH_ALL_REGULAR_EXPENSE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RegularExpenseActionTypes.FETCH_ALL_REGULAR_EXPENSE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case RegularExpenseActionTypes.FETCH_ONE_REGULAR_EXPENSE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case RegularExpenseActionTypes.FETCH_ONE_REGULAR_EXPENSE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case RegularExpenseActionTypes.FETCH_ONE_REGULAR_EXPENSE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RegularExpenseActionTypes.FETCH_ONE_REGULAR_EXPENSE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default RegularExpenseReducer;
